









import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import { FileInfo, VFS } from '@/api/types'
import filepath from '@/api/filepath'
import FileViewerHTML from '@/views/FileViewerHTML.vue'
import FileViewerImage from '@/views/FileViewerImage.vue'
import FileViewerVideo from '@/views/FileViewerVideo.vue'
import Loader from '@/components/Loader.vue'
import mime from 'mime'
import { PageConfig } from '@/store/modules/PageConfigs'

type Dictionary<T> = { [key: string]: T }

interface RouterLink {
  name?: string;
  params?: { [key: string]: string };
  path?: string;
  query?: Dictionary<string | (string | null)[]>;
}

interface FileInfoWithRouterLink extends FileInfo {
  Link?: RouterLink;
}

@Component({
  name: 'ExplorerGalery',
  components: {
    Loader
  }
})
export default class App extends Vue {
  @Prop() files!: FileInfoWithRouterLink[]
  @Prop() xattr!: string[]
  @Prop() vfs!: Promise<VFS>
  @Prop() pageConfig!: PageConfig
  private f: FileInfoWithRouterLink[]
  private currIdx = 0
  private fileSrc = ''
  private viewComponent: unknown = FileViewerHTML
  private isLoading = true

  constructor () {
    super()
    this.f = this.files.filter((f: FileInfoWithRouterLink) => !f.IsDir)
    this.currIdxChanged(0)
  }

  async mounted () {
    this.vfs.then((vfs: VFS) => {
      vfs.ResolveFilename(filepath.join(this.$route.path, this.f[this.currIdx].Link?.path || '')).then((u) => {
        this.fileSrc = u
        this.isLoading = false
      })
    })
  }

  private next () {
    let idx = this.currIdx
    idx += 1
    if (idx === this.f.length) {
      idx = 0
    }
    this.currIdx = idx
  }

  private prev () {
    let idx = this.currIdx
    idx -= 1
    if (idx === -1) {
      idx = this.f.length - 1
    }
    this.currIdx = idx
  }

  @Watch('currIdx')
  currIdxChanged (newValue: number) {
    this.isLoading = true
    this.vfs.then((vfs: VFS) => {
      vfs.ResolveFilename(filepath.join(this.$route.path, this.f[newValue].Link?.path || '')).then((u) => {
        this.fileSrc = u
        const type = mime.getType(u)?.split('/')[0]
        switch (type) {
          case 'image':
            this.viewComponent = FileViewerImage
            break
          case 'video':
            this.viewComponent = FileViewerVideo
            break
          case 'text':
            this.viewComponent = FileViewerHTML
            break
        }
        this.isLoading = false
      })
    })
  }
}

